import { ReactComponent as AddIcon } from "../../../images/icons/glassPlus.svg";
import { ReactComponent as InstalledIcon } from "../../../images/icons/gear-check.svg";
import { ReactComponent as UpgradeIcon } from "../../../images/icons/glassUpArrow.svg";
import { ReactComponent as DowngradeIcon } from "../../../images/icons/glassDownArrow.svg";
import logFetchError from "../../../utils/LoggingUtils.js";
import {UserUtils} from "../../../utils/UserUtils.js";
import {VersionUtils} from "../../../utils/VersionUtils.js";
import "../../../css/installers-view.scss"

export default function ModuleVersionElement({installerId, moduleSource, moduleVersion, installedVersion})
{
    const versionIndicator = VersionUtils.isVersionHigher(moduleVersion.version, installedVersion);

    function installFromSource()
    {
        const request = {
            moduleId: moduleSource.moduleId,
            moduleVersion: moduleVersion.version,
            sourceName: moduleSource.name,
            sourceOwner: moduleSource.owner,
            installerId: installerId,
            sourceUrl: moduleVersion.url
        };

        fetch("admin/api/install-module", {
            credentials: "include",
            method: "POST",
            body: JSON.stringify(request),
            headers: { "Content-Type": 'application/json' },
        })
        .then(res =>
        {
            if(res.ok) window.location.reload()
            else logFetchError(res);
        });
    }

    const incompatible = VersionUtils.hasMajorOrMinorDifference(UserUtils.getVersion(), moduleVersion.compatibleForgeVersion);
    const unstable = UserUtils.getVersion() !== moduleVersion.compatibleForgeVersion && !incompatible;
    const notInstallable = incompatible || versionIndicator === 0;

    const date = new Date(moduleVersion.releaseDate);

    return (
        <div className={"version-source" + (notInstallable ? " disabled" : "")}>
            <div className="version-elem">{moduleVersion.version}</div>
            <div className="version-elem">
                {moduleVersion.compatibleForgeVersion}
                {incompatible && (<span className="error">*</span>)}
                {unstable && (<span className="warning">*</span>)}
            </div>
            <div className="version-elem">{date.toLocaleDateString()}</div>
            {
                (versionIndicator === 0) && <InstalledIcon
                    className="installed-icon"
                />
            }
            {
                (!notInstallable && versionIndicator === 2) && <AddIcon
                    className="install-button"
                    onClick={installFromSource}
                />
            }
            {
                (!notInstallable && versionIndicator === 1) && <UpgradeIcon
                    className="install-button"
                    onClick={installFromSource}
                />
            }
            {
                (!notInstallable && versionIndicator === -1) && <DowngradeIcon
                    className="install-button"
                    onClick={installFromSource}
                />
            }
        </div>
    );
}